import {SHA1} from "crypto-js";

/**
 * Returns the first 8 characters of the SHA1 hash of the given text
 * @param text
 */
export function getShortHash(text: string) {
    return SHA1(text).toString().substring(0,8)
}